import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FOLLOW_CREATIVESET_FEATURE_KEY, FollowCreativeSetState } from './follow-creativeset.reducer';

export const getFollowCreativeSetState = createFeatureSelector<FollowCreativeSetState>(
    FOLLOW_CREATIVESET_FEATURE_KEY
);

export const getFollowCreativeSetLoaded = createSelector(
    getFollowCreativeSetState,
    ({ loaded }) => loaded
);

export const getError = createSelector(getFollowCreativeSetState, state => state.error);

export const getIsFollower = createSelector(getFollowCreativeSetState, ({ isFollower }) => isFollower);

export const getUserEmail = createSelector(getFollowCreativeSetState, ({ userEmail }) => userEmail);

export const getUserName = createSelector(getFollowCreativeSetState, ({ userName }) => userName);
